import PropTypes from 'prop-types';
import { Component } from 'react';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class NumberInput extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = ({
      target: {
        value
      }
    }) => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      return this.props.onChange(value);
    };
  }
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      autoFocus,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      id,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      increment,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      max,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      min,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      placeholder,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      value
    } = this.props;
    const inputProps = {
      autoFocus,
      disabled,
      id,
      max,
      min,
      onChange: this.onChange,
      placeholder,
      readOnly,
      value
    };
    if (increment) {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      return /*#__PURE__*/_jsx(UIStepperInput, Object.assign({}, inputProps, {
        stepSize: increment
      }));
    }
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    return /*#__PURE__*/_jsx(UINumberInput, Object.assign({}, inputProps));
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
NumberInput.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  format: PropTypes.string,
  id: PropTypes.string,
  increment: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};